export enum DataLayerKey {
    Country = 'country',
    EnvChannel = 'env_channel',
    EnvCountry = 'env_country',
    EnvLanguage = 'env_language',
    EnvPlatform = 'env_platform',
    EnvTemplate = 'env_template',
    EnvWork = 'env_work',
    FavoriteCreditCardDeclared = 'favorite_credit_card_declared',
    FavoriteOrderAddressDeclared = 'favorite_order_address_declared',
    PageName = 'page_name',
    PageTopCat = 'page_top_cat',
    UserCardOwner = 'user_card_owner',
    UserEmail = 'user_email',
    UserEmailOptin = 'user_email_optin',
    UserGender = 'user_gender',
    UserId = 'user_id',
    UserIdentified = 'user_identified',
    UserInscriptionDate = 'user_inscription_date',
    UserLogged = 'user_logged',
    UserLoyaltyCategory = 'user_loyalty_category',
    UserNewCustomer = 'user_newcustomer',
    UserPurchaseFrequency = 'user_purchase_frequency',
    UserStore = 'user_store',
    UserType = 'user_type',
    UserWithOffer = 'user_with_offer',
    ProductDisplayType = 'product_display_type',
    ProductPid = 'product_pid',
    ProductCategoryId = 'product_category_id',
    EnvHeadless = 'env_headless',
    ProductSku = 'product_sku',

    PageCat = 'page_cat',
    PageSubCat = 'page_sub_cat',
    PageTrademark = 'page_trademark',
    ProductAxis = 'product_axis',
    ProductBrand = 'product_brand',
    ProductBreadcrumbId = 'product_breadcrumb_id',
    ProductBreadcrumbLabel = 'product_breadcrumb_label',
    ProductCop = 'product_cop',
    ProductCurrency = 'product_currency',
    ProductCustomizable = 'product_customizable',
    ProductCustomized = 'product_customized',
    ProductDefaultSku = 'product_default_sku',
    ProductDiscountAti = 'product_discount_ati',
    ProductDiscountTf = 'product_discount_tf',
    ProductFidelityPoints = 'product_fidelity_points',
    ProductInstock = 'product_instock',
    ProductMarket = 'product_market',
    ProductNature = 'product_nature',
    ProductNumRating = 'product_num_rating',
    ProductOldPriceAti = 'product_old_price_ati',
    ProductOldPriceTf = 'product_old_price_tf',
    ProductPidName = 'product_pid_name',
    ProductPriceAti = 'product_price_ati',
    ProductPriceTf = 'product_price_tf',
    ProductPromotion = 'product_promotion',
    ProductRange = 'product_range',
    ProductRating = 'product_rating',
    ProductSection = 'product_section',
    ProductSkuCoverage = 'product_sku_coverage',
    ProductSkuName = 'product_sku_name',
    ProductSubbrand = 'product_subbrand',
    ProductTarget = 'product_target',
    ProductTrademark = 'product_trademark',
    ProductTravelSizeAvailability = 'product_travel_size_availability',
    ProductUrlPicture = 'product_url_picture',
    ProductVideo = 'product_video',
}
